<template>
  <div class="field" :class="{ 'visible-title': label }">
    <div class="field-title" v-if="label">
      <slot name="field-item-label">{{label}}
        <tooltip-icon v-if="tip" placement="right" popperClass="field-tooltip" :content="tip"></tooltip-icon>
      </slot>
    </div>
    <div class="field-content">
      <slot></slot>
    </div>
  </div>
</template>

<script lang="js">
export default {
  name: 'FieldContainerCmp',
  props: {
    label: String,
    tip: String
  }
}

</script>

<style scoped>
  .field {
    display: flex;
    flex-direction: row;
    align-items: center;
    flex-grow: 1;
    text-align: left;
    background: #e2f1f6;
    border: 1px solid #c0d5ef;
    padding: 14px;
    min-height: 32px;
  }

  .field:not(:last-child) {
    margin-bottom: 10px;
  }

  .field > .field-content {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    width: calc(100% - 28px);
  }

  .field.visible-title > .field-content {
    display: flex;
    flex-direction: row;
    align-items: center;
    text-align: left;
    color: #394445;
    padding: 14px;
    width: 100%;
  }

  .field.visible-title {
    padding: 0;
    align-items: stretch;
  }

  .field.visible-title > .field-title {
    display: flex;
    flex-direction: row;
    align-items: center;
    flex-shrink: 0;
    text-align: left;
    color: #394445;
    width: 270px;
    padding: 14px;
    background: #c0d5ef;
  }
</style>
<style>
  .el-tooltip__popper.is-dark.field-tooltip {
    max-width: 400px;
  }
</style>



// WEBPACK FOOTER //
// src/components/form/field.vue